import classNames from 'classnames';
import {formatMoney} from 'lib/formatters';
import {GridGroupAdditional} from 'modules/ProductsGrid/components/GridGroupAdditional/GridGroupAdditional';
import {ProductGridItem} from 'modules/ProductsGrid/components/ProductGridItem/ProductGridItem';
import {ProductsGridGroupState} from 'modules/ProductsGrid/containers/ProductsGridContainer/reducer';
import {
    ProductGridItemData,
    ProductsGridTotal,
} from 'modules/ProductsGrid/lib/types';
import {FC} from 'react';

import styles from './GridGroup.module.css';

type Props = {
    group: ProductsGridGroupState;
    groupTotal: ProductsGridTotal;
    products: Record<number, ProductGridItemData>;
    previewIsClickable: boolean;

    makeHandleRemove: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleRestore: ({
        productId,
        groupId,
    }: {
        productId: number;
        groupId: number;
    }) => () => void;
    makeHandleChangeCount: (id: number) => (count: number) => void;
    makeHandlePreviewClick: (id: number) => () => void;
};
export const GridGroup: FC<Props> = ({
    group,
    groupTotal,
    products,
    previewIsClickable,
    makeHandleRemove,
    makeHandleRestore,
    makeHandleChangeCount,
    makeHandlePreviewClick,
}) => {
    const priceIsChanged = groupTotal.price.old !== groupTotal.price.current;

    return (
        <div className={styles.group}>
            {group.products.length > 0 && (
                <div className={styles.groupHead}>
                    <div className={styles.groupHeadName}>{group.name}</div>
                    <div className={styles.groupHeadCount}>
                        {groupTotal.count}
                        <span> наименований</span>
                    </div>
                    {groupTotal.price.current !== 0 && (
                        <div className={styles.groupHeadTotal}>
                            <div className={classNames(styles.price)}>
                                {priceIsChanged && (
                                    <div className={styles.priceOld}>
                                        {formatMoney(groupTotal.price.old)}
                                    </div>
                                )}
                                <div className={styles.priceCurrent}>
                                    {formatMoney(groupTotal.price.current)}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            {group.products.map((productId) => {
                const product = products[productId];
                return (
                    <ProductGridItem
                        key={product.id}
                        className={styles.product}
                        data={product}
                        amount={product.count}
                        removed={product.deleted}
                        onChangeCount={makeHandleChangeCount(product.id)}
                        onRestore={makeHandleRestore({
                            productId: product.id,
                            groupId: group.id,
                        })}
                        onRemove={makeHandleRemove({
                            productId: product.id,
                            groupId: group.id,
                        })}
                        onPreviewClick={
                            previewIsClickable
                                ? makeHandlePreviewClick(product.id)
                                : undefined
                        }
                    />
                );
            })}

            {group.additionalProducts.length > 0 && (
                <div className={styles.additionalGoods}>
                    <GridGroupAdditional
                        groupId={group.id}
                        productsEntities={products}
                        parentId={group.parentId}
                        productsList={group.additionalProducts}
                        previewIsClickable={previewIsClickable}
                        makeHandleRemove={makeHandleRemove}
                        makeHandleRestore={makeHandleRestore}
                        makeHandleChangeCount={makeHandleChangeCount}
                        makeHandlePreviewClick={makeHandlePreviewClick}
                    />
                </div>
            )}
        </div>
    );
};
